<template>
	<b-container class="w-75 text-dark">
		<b-row class="heading p-4">
			<b-col>
				<h2 class="h3 text-center">Welcome!</h2>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	export default
	{
		name: 'home',
		data() { return {}; }
	}
</script>

<style scoped>
</style>
